import { Check, Sparkles, ArrowUpRight } from "lucide-react";
import styles from "./marketing.module.css";

export function BuddyStoryFrame({
  phase,
  checkout,
}: {
  phase: number;
  checkout: boolean;
}) {
  if (phase === 8)
    return (
      <div className={styles.insightFrame} key="insights">
        <span className={styles.insightLabel}>AI Insights</span>
        <Sparkles size={32} />
        <h3>
          Small details.
          <br />
          Useful discoveries.
        </h3>
        <div className={styles.insightNote}>
          <small>PRODUCT INFORMATION OPPORTUNITY</small>
          <strong>Make laptop compatibility easier to find.</strong>
          <p>
            The shopper asked about laptop size. Highlighting this detail could
            help the next visitor.
          </p>
        </div>
        <p>
          Suggestions for you to review. Your store information is never edited
          automatically.
        </p>
      </div>
    );
  if (phase === 9)
    return (
      <div className={styles.finaleFrame} key="finale">
        <Sparkles size={52} strokeWidth={1.3} />
        <h3>
          All together.
          <br />
          All Buddy.
        </h3>
        <p>
          A better shopping experience.
          <br />A little more knowledge for your store.
        </p>
      </div>
    );
  if (phase === 7)
    return (
      <div className={styles.cartFrame} key={checkout ? "checkout" : "cart"}>
        <span className={styles.demoSuccess}>
          <Check size={18} />
          {checkout ? "Ready for checkout" : "Added to your cart"}
        </span>
        <div className={styles.productArt}>
          <div className={styles.bag} />
        </div>
        <h3>Everyday Weekender</h3>
        <p>Sand · Canvas · 1 item</p>
        <div className={styles.cartTotal}>
          <span>Your 10% offer</span>
          <strong>
            $108.00 <s>$120.00</s>
          </strong>
        </div>
        <div className={styles.demoAction}>
          {checkout ? "Your store’s secure checkout" : "Continue to checkout"}
          <ArrowUpRight size={18} />
        </div>
      </div>
    );
  if (phase === 4 || phase === 5)
    return (
      <div className={styles.discoveryFrame} key={phase}>
        <small>THOUGHTFUL ESSENTIALS, PICKED FOR YOU</small>
        <h3>
          {phase === 4 ? "Find your next favorite." : "Room for the weekend."}
        </h3>
        <div className={styles.productArt}>
          <div className={styles.bag} />
        </div>
        <strong>Everyday Weekender</strong>
        <p>{phase === 4 ? "$120.00 · Sand" : "$108.00 with your 10% offer"}</p>
        <div className={styles.demoAction}>
          Ask Buddy about this product
          <Sparkles size={18} />
        </div>
      </div>
    );
  const question =
    phase <= 1
      ? "I need a bag for a weekend away. Is your canvas water-resistant?"
      : phase === 2
        ? "Something roomy, but still easy to carry."
        : phase === 3
          ? "I like it. Is there a better price?"
          : "Will it fit my 15-inch laptop?";
  const answer =
    phase <= 1
      ? "Yes—our canvas has a water-resistant finish for light rain. Let’s find a good fit for your trip."
      : phase === 2
        ? "Meet the Everyday Weekender. Room for a few days away, with a detachable shoulder strap."
        : phase === 3
          ? "I can offer 10% off the Weekender, within this store’s discount rules."
          : "Yes! The Weekender fits laptops up to 16 inches, with room for your weekend essentials.";
  return (
    <div className={styles.chatFrame} key={phase}>
      <p className={styles.shopperMessage}>{question}</p>
      <div className={styles.buddyMessage}>
        <span>
          <Sparkles size={16} />
          Buddy AI
        </span>
        {phase === 0 ? (
          <div className={styles.typing} aria-label="Buddy is replying">
            <i />
            <i />
            <i />
          </div>
        ) : (
          <p>{answer}</p>
        )}
      </div>
      {phase >= 2 && (
        <div className={styles.chatProduct}>
          <div className={styles.productArt}>
            <div className={styles.bag} />
          </div>
          <strong>Everyday Weekender</strong>
          <span>
            {phase === 3 ? "$108.00 · Your 10% offer" : "$120.00 · Sand"}
          </span>
        </div>
      )}
      <span className={styles.chatHint}>
        A conversation shaped around your store.
      </span>
    </div>
  );
}
